import { useState } from "react";
import moment from "moment";
import { Dropdown } from "antd";
import Down from "helper/Icons/DownIcon";
import Calendar from 'react-calendar'

const DateFilter = ({ filters, setFilters }) => {
	const [selectedDates, setSelectedDates] = useState<string[]>([]);
	const [parms, setParms] = useState<any>({});
	const [open, setOpen] = useState(0)

	const handleTileClick = date => {
		const formattedDate = moment(date).format('YYYY-MM-DD')
		if (!selectedDates.includes(formattedDate)) {
			setSelectedDates([...selectedDates, formattedDate])
		} else {
			setSelectedDates(selectedDates.filter(d => d !== formattedDate))
		}
	}

	const clearDates = () => {
  setSelectedDates([]);
  setFilters(prev => {
    const { dates, ...rest } = prev;
    return rest;
  });
};
	const applyDates = () => {
		setOpen(0);

		setFilters(prev => ({
			...prev,
			dates: selectedDates.map(i =>
				moment(i).utc().format()
			),
		}));
	};

	const dateFilters = [
		{
			key: 'datefilter',
			label: (
				<div>
					<Calendar
						calendarType="US"
						onClickDay={handleTileClick}
						tileClassName={({ date }) => {
							const formattedDate = moment(date).format('YYYY-MM-DD')
							return selectedDates.includes(formattedDate) ? 'selected' : ''
						}}
					/>
					<div className="flex justify-between mx-15px mt-10px">
						<button className="clr-btn" onClick={clearDates}>
							Clear
						</button>
						<button className="aply-btn" onClick={applyDates}>
							Apply
						</button>
					</div>
				</div>
			),
		},
	]

	return (
		<><Dropdown
			menu={{
				items: dateFilters,
			}}
			placement="bottomLeft"
			arrow={false}
			className="mr-10px"
			open={open === 4}
			onOpenChange={(flag) => setOpen(flag ? 4 : 0)}
			overlayStyle={{ width: '350px' }}
			overlayClassName="custom-dropdown-overlay"
		>
			<button
				className={` ${open === 4 ? 'filter-btn-click' : 'filter-btn'
					} w-500`}
				onClick={() => {
					setOpen(open === 4 ? 0 : 4)
				}}
				style={{ cursor: 'pointer' }}
			>
				Date <Down />
			</button>
		</Dropdown>
		</>
	)
}

export default DateFilter